(function dynamicEmailDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlEmail', [])
        .directive('dynamicEmail', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-email/custom-control-email-template.html'
            };
        });

    angular.module('CustomControlEmail')
       .directive('dynamicFilterEmail', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-email/custom-control-filter-email-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function($scope) {
                       if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                           $scope.data.metadataSearchTypeFrom = 'EqualIgnoreCase';
                       }
                   }
               ]
           };
       }]);
})();